export default "/images/7.png?9262a0607e7dffd99c1600ed0a481498";